import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-40b8541c")

_pushScopeId("data-v-40b8541c")
const _hoisted_1 = { class: "display-flex" }
const _hoisted_2 = { class: "label-title flex1" }
const _hoisted_3 = { class: "label-content flex1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = { class: "display-flex" }
const _hoisted_6 = { class: "label-title flex1" }
const _hoisted_7 = { class: "label-content flex1" }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { class: "display-flex" }
const _hoisted_10 = { class: "flex1" }
const _hoisted_11 = { class: "label-content flex1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.data.Object,
    footerType: "customize"
  }, {
    footer: _withId(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$wordList.ProperAllTextPackageFee), 1),
        _createVNode("label", _hoisted_3, " $" + _toDisplayString(_ctx.data.MonthlyFee), 1)
      ]),
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$wordList.ProperAllTextSuscriptionDuration), 1),
        _createVNode("label", _hoisted_7, _toDisplayString(_ctx.data.Days) + " " + _toDisplayString(_ctx.$wordList.Days), 1)
      ]),
      _hoisted_8,
      _createVNode("div", _hoisted_9, [
        _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$wordList.OrderTotalPrice) + "  ", 1),
        _createVNode("label", _hoisted_11, "    $" + _toDisplayString(_ctx.data.Price), 1)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})